export enum enmPrintOrientationType {
    LANDSCAPE = 1,
    PORTRAIT = 2
}